import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class CandidatesDataService {

    constructor(private http: HttpClient) {
    }

    // Get all candidates
    getAllCandidates() {
        return this.http.get('agri/crm/getAllCandidates');
    }

    listCandidatesFiltered(size, page, sort, order, candidatesBody: object){
        return this.http.post('agri/listCandidatesFiltered?page=' + (page-1) + '&size=' + size + '&sort=' + sort + '&dir=' + order, candidatesBody);
    }

    addToBlackList(body: object) {
        return this.http.post('agri/addToBlackList', body);
    }

    deleteFromBlackList(userId: string, type: string) {
        return this.http.delete('agri/deleteFromBlackList?userId='+ userId + '&type=' + type);
    }
}
